export const customSelect = {
  control: (provided, state) => {
    const focusBorderColor = "rgb(114, 61, 240)"; // Purple-600
    const boxShadow = "0 0 0 4px rgba(139, 92, 246, 0.2)"; // Purple-600
    
    return {
      ...provided,
      width: "100%",
      padding: "3px",
      borderRadius: "8px",
      // If focused, use transparent border then override with focusBorderColor below
      border: state.isFocused ? "2px solid rgb(114, 61, 240)" : "2px solid #e5e7eb",
      backgroundColor: "rgba(255, 255, 255, 0.9)",
      boxShadow: state.isFocused ? boxShadow : provided.boxShadow,
      transition: "all 0.3s ease-in-out",
      "&:hover": {
        borderColor: "rgb(114, 61, 240)",
        transition: "border-color 0.3s ease",
      },
      // Override borderColor on focus
      ...(state.isFocused && { borderColor: focusBorderColor }),
    };
  },
  input: (provided) => ({
    ...provided,
    color: "#111827", // Sets the input text color
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#6b7280", // Placeholder text color
  }),
  menu: (provided) => ({
    ...provided,
    maxHeight: "auto", // Remove height constraint from the entire menu
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: "170px",  // Set height for the options container
    overflowY: "auto",   // Enable scrolling within the options container
    scrollBehavior: "smooth", // Smooth scrolling behavior
  }),
  // Ensure portal menus sit above other elements
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999
  })
};